import * as Icons from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface Props {
  icon: string;
  title: string;
  description?: string;
  dirtyCount: number;
}

// Kept as a pure string transform (rather than returning the icon component
// itself) so the lookup below is a plain property access, not a call whose
// result feeds a JSX tag -- react-hooks/static-components flags a dynamic
// component created during render (#1123).
function iconKey(name: string): string {
  return name.split('-').map((w) => w[0].toUpperCase() + w.slice(1)).join('');
}

export function SectionHeader({ icon, title, description, dirtyCount }: Props) {
  const iconMap: Record<string, any> = Icons;
  const Icon = iconMap[iconKey(icon)] ?? Icons.Settings;
  return (
    <div className="mb-4 flex items-start gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
        <Icon className="h-4 w-4" aria-hidden />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-semibold tracking-tight">{title}</h3>
        {description && (
          <p className="text-[13px] font-normal text-muted-foreground">{description}</p>
        )}
      </div>
      {dirtyCount > 0 && (
        <Badge variant="default" className="shrink-0">
          <span aria-hidden className="mr-1 text-[8px]">●</span>
          {dirtyCount} edited
        </Badge>
      )}
    </div>
  );
}
